import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAppRoomTypeAvailableColumns } from './api';

export const path = '/app/room-type/list';

const PageAppRoomType: React.FC = (props) => {
  const AppRoomType = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getAppRoomTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <AppRoomType {...props} />;
};

export default PageAppRoomType;
